import { API_URL } from "src/utilities";
import defaultUser from "../utilities/default-user";

export async function getUser() {
  try {
    const token = localStorage.getItem("Token");

    if (!token) {
      return {
        isOk: false,
        data: null,
      };
    }

    // دریافت اطلاعات کامل کاربر از API
    const response = await fetch(`${API_URL}user/profile`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    if (response.ok) {
      const userData = await response.json();

      return {
        isOk: true,
        data: userData,
      };
    } else if (response.status === 401) {
      // Token نامعتبر
      console.warn("🔐 Token نامعتبر، نیاز به login مجدد");
      return {
        isOk: false,
        data: null,
      };
    } else {
      // سایر خطاهای API - کاربر را با داده‌های localStorage authenticate کن
      console.warn("⚠️ خطا در دریافت اطلاعات کاربر از API، استفاده از localStorage");
      const userFromStorage = {
        token,
        email: localStorage.getItem("Email") || "",
        userName: localStorage.getItem("UserName") || "",
        id: localStorage.getItem("UserId") || "",
      };
      return {
        isOk: true,
        data: userFromStorage,
      };
    }
  } catch (error) {
    console.error("❌ خطا در اتصال به API:", error);
    // در صورت خطا در اتصال، از localStorage استفاده کن
    const userFromStorage = {
      token: localStorage.getItem("Token") || "",
      email: localStorage.getItem("Email") || "",
      userName: localStorage.getItem("UserName") || "",
      id: localStorage.getItem("UserId") || "",
    };
    return {
      isOk: true,
      data: userFromStorage,
    };
  }
}

export async function changePassword(email: string, recoveryCode?: string) {
  try {
    // Send request
    console.log(email, recoveryCode);

    return {
      isOk: true,
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to change password",
    };
  }
}

export async function resetPassword(email: string) {
  try {
    // Send request
    console.log(email);

    return {
      isOk: true,
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to reset password",
    };
  }
}
